<template>
    <div class="table_wrap">
        <div class="table_search row has_bc">
            <el-row>
                <el-col :span="12">
                </el-col>
                <el-col :span="12" class="text_right">
                </el-col>
            </el-row>
        </div>
<!--  #todo api 작업 미완료인해 추후 작업 필요      -->
        <el-table
                :data="declarationData"
                style="width: 100%"
                empty-text="데이터가 없습니다."
                @selection-change="tableSelectChange"

        >
            <el-table-column
                    type="selection"
                    width="55"
                    class-name="text-center"
            >
            </el-table-column>
            <el-table-column
                    class="table_no"
                    type="index"
                    label="No"
                    width="80"
                    class-name="num text-center"
                    :index="tableIdx"
            >
            </el-table-column>
            <el-table-column
                    label="분류" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ returnDeclarationType(scope.row.bb_type) }}
                    </span>
                </template>
            </el-table-column>

            <el-table-column label="신고자닉네임" prop="writer_nick" class-name="text-center"></el-table-column>
            <el-table-column label="신고당한닉네임" prop="declarer_nick" class-name="text-center"></el-table-column>
            <el-table-column label="신고일자" prop="fa_subject" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ returnDate(scope.row.created_at) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    label="옵션" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <div>
                        <el-button
                                size="mini"
                                type="warning"
                                @click="openDetailModal('declaration-detail-modal',scope.row)"
                        >
                            상세
                        </el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                    label="처리상태" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <div>
                        <el-button
                                size="mini"
                                :type="checkStatusBtn(scope.row.bb_status)"
                                @click="openDetailModal('declaration-status-modal',scope.row)"
                        >
                            {{ returnDeclarationStatus(scope.row.bb_status) }}
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>

</template>

<script>
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";

export default {
    name: "DeclarationListDefaultLayout",
    mixins: [],
    inject: ['declarationListSetData'],
    components: {},
    provide() {
        return {}
    },
    props: {
        declarationData: {default: () => []},
        paginationData: {
            default: () => {
                return {total: 0, page: 0, size: 0,}
            }
        },
    },
    data() {
        return {
            selectArr: [],
            statusBtn:'info',
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        tableSelectChange(row) {
            this.selectArr = [];
            util.Array.each(row, (obj, index, arr) => {
                this.selectArr.push(obj.bb_idx);
            });
            this.declarationListSetData('selectArr', this.selectArr)
        },
        toggleCheckClass({row, rowIndex}) {
            return this.selectArr.indexOf(row.bb_idx) > -1 ? 'select' : '';
        },
        returnDate(date = null) {
            if (!date) {
                return '';
            }
            return this.$moment.unix(date).locale('ko').format('YYYY-MM-DD HH:mm')
        },
        tableIdx(index) {
            return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
        },
        returnDeclarationType(type) {
            if (type === 0) {
                return '라이브(대기)'
            } else if (type === 1) {
                return '라이브(진행,종료)'
            } else if (type === 2) {
                return '댓글'
            } else if (type === 3) {
                return '포스트';
            }
        },
        returnDeclarationStatus(type) {
            if (type === 1) {
                this.statusBtn = 'info'
                return '처리대기'
            } else if (type === 2) {
                return '처리'
            } else if (type === 3) {
                this.statusBtn = 'Primary'
                return '처리완료';
            }
        },
        checkStatusBtn(type){
            if (type === 1) {
                return 'info'
            } else if (type === 2) {
                return 'warning'
            } else if (type === 3) {
                return 'primary'
            }
        },
        openDetailModal(name, data) {
            this.$modal.show(name, {declarationData: data});
        },
        goDetail(data) {
            this.$router.push(`${this.$route.path}/${data}`)
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>